<template>
  <div
    class="flex h-14 w-14 basis-14 items-center text-center tablet:h-20 tablet:w-20 tablet:basis-20"
    :class="provideContainerStyle"
  >
    <span
      class="block text-2xl font-bold leading-[3.5rem] after:m-auto after:block after:h-1 after:w-14 after:rounded-md after:bg-blue-400 after:content-[''] tablet:text-[30px]"
    >
      {{ stepDigitText }}
    </span>
  </div>
</template>

<script setup lang="ts">
  interface IProps {
    stepDigit: number;
    stepAligns?: string;
  }

  const props = withDefaults(defineProps<IProps>(), {
    stepAligns: 'left',
  });

  const provideContainerStyle = computed((): string => {
    switch (props.stepAligns) {
      case 'center':
        return 'justify-center';
      case 'right':
        return 'justify-end';
      default:
        return 'justify-start';
    }
  });

  const stepDigitText = computed((): string => digitFormat(props.stepDigit));

  const digitFormat = (digit: number): string => {
    if (digit < 10) {
      return `0${digit}`;
    }
    return `${digit}`;
  };
</script>
